import { Box, Grid } from '@mui/material';
import {
	ArrayInput,
	BooleanInput,
	Edit,
	NumberInput,
	ReferenceArrayInput,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	SimpleFormIterator,
	TextInput,
} from 'react-admin';

export const SurveyQuestionEdit = () => (
	<Edit>
		<SimpleForm>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<TextInput fullWidth source="question.he" label="Question (Hebrew)" />
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextInput fullWidth source="question.en" label="Question (English)" />
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextInput fullWidth source="slug" label="Slug" />
				</Grid>
				<Grid item xs={12} sm={3}>
					<SelectInput source="type" choices={[{ id: 'multiChoice', name: 'Multi Choice' }]} />
				</Grid>
				<Box width={'100%'} />
				<Grid item xs={12}>
					<ArrayInput source="options">
						<SimpleFormIterator inline>
							<TextInput source="text.he" />
							<NumberInput source="value" />
							<BooleanInput source="free_text" />
						</SimpleFormIterator>
					</ArrayInput>
				</Grid>
				<Box width={'100%'} />
				<Grid item xs={12} sm={4}>
					<ReferenceArrayInput
						reference="company"
						source={`hide_for_company`}
						label="הסתר מחברות"
						fullWidth
						perPage={999}
					>
						<SelectArrayInput optionText="english_name" optionValue="_id" fullWidth />
					</ReferenceArrayInput>
				</Grid>

				<Grid item xs={12} sm={4}>
					<ReferenceArrayInput
						reference="company"
						source={`show_for_company`}
						label="הצג לחברות"
						fullWidth
						perPage={999}
					>
						<SelectArrayInput optionText="english_name" optionValue="_id" fullWidth />
					</ReferenceArrayInput>
				</Grid>
				<Box width={'100%'} />
				<Grid item xs={12} sm={4}>
					<SelectArrayInput
						source={`hide_for_type`}
						fullWidth
						choices={[
							{ name: 'newborn_3m', id: 'newborn_3m' },
							{ name: 'newborn_6m', id: 'newborn_6m' },
							{ name: 'trial', id: 'trial' },
						]}
					/>
				</Grid>

				<Grid item xs={12} sm={2}>
					<BooleanInput source="visible" />
				</Grid>

				<Grid item xs={12} sm={2}>
					<BooleanInput source="is_dating_question" />
				</Grid>

				<Grid item xs={12} sm={2}>
					<NumberInput source="order" />
				</Grid>
			</Grid>
		</SimpleForm>
	</Edit>
);

export default SurveyQuestionEdit;
